
<script>
import { calcDeltaPrice } from '@/utils/helpers'
import {
  RexSelect,
  RexInput
} from '@/components/views/rexFieldsV2'

export default {
  name: 'visa-form',
  components: {
    RexSelect,
    RexInput
  },
  props: {
    formIsShown: {
      type: Boolean,
      default: () => true
    },
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    visaIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    getCountryTo() {
      return this.$store.getters['cart/getLocations'].countryTo
    },
    getVisa() {
      return this.$store.getters['cart/getVisa'](this.visaIndex)
    },
    isLoading() {
      return this.getVisa.isLoading
    },
    getVisaCities() {
      return this.$store.getters['cart/getVisaCities'](this.visaIndex)
    },
    getVisaCollection() {
      const selectedVisas = this.getVisa.selected

      const result = this.getVisa.collection
        .map((collectionItem, index) => collectionItem
          .map((item) => {
            const currentVisa = collectionItem.find(x => x.slug === selectedVisas[index])
            const currentVisaPriceAmount = currentVisa && selectedVisas[index]
              ? currentVisa.price.amount
              : 0

            return {
              slug: item.slug,
              name: `${item.name} ${calcDeltaPrice(currentVisaPriceAmount, item.price.amount)} ${item.price.currency}`
            }
          }))

      return result
    },
    numberOfTourists() {
      return this.$store.getters['cart/getNumberOfTourists'].total
    },
    getVisaDuration() {
      const {
        startDate,
        endDate
      } = this.$store.getters['cart/getDates']

      return `${startDate} - ${endDate}`
    }
  },
  watch: {
    'numberOfTourists'() {
      this.setBaseLength()
    }
  },
  created() {
    if (!this.mainServiceIsTours) {
      this.$store.dispatch('cart/getVisaCities', {
        visaIndex: this.visaIndex,
        countryId: this.getCountryTo.slug
      })

      this.setBaseLength()
    }
  },
  methods: {
    setBaseLength() {
      this.$store.commit('cart/setCollectionBaseLength', {
        visaIndex: this.visaIndex,
        length: this.numberOfTourists
      })
      this.$store.commit('cart/setSelectedBaseLength', {
        visaIndex: this.visaIndex,
        length: this.numberOfTourists
      })
      this.$store.commit('cart/setLoadingBaseLength', {
        visaIndex: this.visaIndex,
        length: this.numberOfTourists
      })
      this.$store.commit('cart/setIdsBaseLength', {
        visaIndex: this.visaIndex,
        length: this.numberOfTourists
      })
    },
    selectCity({ event: cityIds }, touristIndex) {
      this.$store.commit('cart/resetVisaCollection', {
        visaIndex: this.visaIndex,
        touristIndex
      })

      this.$store.commit('cart/updateVisaCurrent', {
        target: `visas.${this.visaIndex}.visas.selected.${touristIndex}`,
        value: null
      })

      if (this.mainServiceIsTours) {
        this.$store.commit('cart/setVisaVisas', {
          touristIndex,
          visaIndex: this.visaIndex,
          data: {
            ...this.$store.getters['cart/getToursVisasIds'](this.visaIndex),
            results: this.$store.getters['cart/getToursVisas']({
              visaIndex: this.visaIndex,
              cityId: cityIds[touristIndex]
            })
          }
        })
      } else {
        this.$store.commit('cart/updateVisaLoadingStatus', {
          touristIndex,
          visaIndex: this.visaIndex,
          status: true
        })

        this.$store.dispatch('cart/getVisas', {
          touristIndex,
          visaIndex: this.visaIndex,
          params: {
            ...this.$store.getters['cart/getVisaFormForSearch']({
              touristIndex,
              visaIndex: this.visaIndex
            })
          }
        })
      }
    }
  }
}
</script>

<template>
  <div class="cart__insurance--tourist cart__insurance-tourist">
    <div class="cart__insurance-tourist--form cart__insurance-tourist-form">
      <div class="cart__insurance-tourist-form--content full-width">
        <div
          v-for="(i, touristIndex) in numberOfTourists"
          :key="touristIndex"
          class="cart__search-form-visas-row"
        >
          <h3 class="cart__search-form-tourist-label">
            Турист {{ touristIndex + 1 }}
          </h3>
          <div class="cart__search-form-visas">
            <rex-input
              label="Страна"
              :name="`${visaIndex}_country`"
              store-module="cart"
              getter="getServiceField"
              setter="updateServiceField"
              :target="`visas.${visaIndex}.fromRender.country`"
              :is-disabled="true"
              :value="getCountryTo.name"
            />
            <rex-input
              label="Дата"
              :name="`${visaIndex}_date`"
              store-module="cart"
              getter="getServiceField"
              setter="updateServiceField"
              :target="`visas.${visaIndex}.fromRender.date`"
              :is-disabled="true"
              :value="getVisaDuration"
            />
            <rex-select
              label="Город выдачи"
              :name="`${visaIndex}_cityId`"
              store-module="cart"
              getter="getServiceField"
              setter="updateServiceField"
              :target="`visas.${visaIndex}.form.cityId`"
              :is-array-select="true"
              :array-select-index="touristIndex"
              :options="getVisaCities"
              :is-disabled="!getVisaCities.length"
              :is-loading="!getVisaCities.length"
              :hide-if-empty="false"
              @change="selectCity($event, touristIndex)"
            />
            <rex-select
              label="тип визы"
              store-module="cart"
              :name="`${visaIndex}_${touristIndex}_cityId`"
              getter="getVisaCurrent"
              setter="updateVisaCurrent"
              :target="`visas.${visaIndex}.visas.selected.${touristIndex}`"
              :options="getVisaCollection[touristIndex]"
              :is-disabled="!isLoading[touristIndex] && !getVisaCollection[touristIndex].length"
              :is-loading="isLoading[touristIndex]"
              :hide-if-empty="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
